import './index.scss'
import { hoverlist } from './hoverlist'
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';
import { createHigherOrderComponent } from '@wordpress/compose';
import { addFilter } from '@wordpress/hooks';

import {	
	InspectorControls, 	
	BlockControls, 	
} from '@wordpress/block-editor';

import {	
	PanelBody,	
	SelectControl,
	ToggleControl
} from '@wordpress/components';


const allowedBlocks = [ 'core/group', 'core/column' ];

const addAttributes = ( settings, name ) => {		

	if ( !allowedBlocks.includes( name ) ) {
		return settings;
	}

	if( typeof settings.attributes !== 'undefined' ){	
		settings.attributes = {
      ...settings.attributes,

			ahover: {
				type: 'object',
				default: {
					hoverOptions: '',      // from your hoverlist
					customHover: '',       // optional for custom hover CSS or future use
				},
			}		
				
		};    
	}
	return settings;
}


const addInspectorControl = createHigherOrderComponent( ( BlockEdit ) => {
	return ( props ) => {

		if ( !allowedBlocks.includes( props.name ) ) {
			return ( <BlockEdit { ...props } /> );
		}

		const {		
			attributes, setAttributes, isSelected,
		} = props;

		const {
			ahover,
		} = attributes;  

		const {
			hoverOptions,
			customHover
		} = ahover;



		const updateObject = (obj, key, newVal) => ({
			...obj,
			[key]: newVal,
		});

		const updateArray = (list, index, newVal) => {
			const listsCopy = [...list];
			listsCopy[index] = newVal;
			return listsCopy;
		};



	
	
		return (
			<>
				<BlockEdit { ...props } />
										
					<InspectorControls group="settings">	

						<PanelBody title={ __( 'Hover Options', 'aver' ) } initialOpen={false}>      
							
							<SelectControl
								label={__('Hover Options', 'aver')}
								options={hoverlist}
								value={ hoverOptions }
								onChange={(newValue) =>
									setAttributes({
										ahover: {...ahover, hoverOptions:  newValue }	})
								}
							/>

					</PanelBody>	
						
				</InspectorControls>			
			</>

		);
	};

}, 'addInspectorControl');


const applyExtraClassEditor = ( BlockListBlock ) => ( props ) => {

	if ( !allowedBlocks.includes( props.name ) ) {
		return ( <BlockListBlock { ...props } />	);
	}

	const { attributes, wrapperProps, className } = props;
	const { ahover } = attributes;

	const {
		hoverOptions,
		customHover
	} = ahover;

	if (hoverOptions === '') {
		return <BlockListBlock {...props} />;
	}
		
	const cssstyle = { 
		...wrapperProps?.style,
	}		

	const classes = classnames(
		className, ``,
		{ 		
			[ `a-hover-${ hoverOptions }` ]: hoverOptions,					
		}
	);

	return (
		<BlockListBlock
			{...props		} 
			wrapperProps={ { style : cssstyle } } 			
			className= { classes }				
		/>
	)
}




const applyExtraClassSave = ( extraProps, blockType, attributes ) => {

	if ( ! allowedBlocks.includes( blockType?.name ) ) {
    return extraProps;
  }

	const { className } = extraProps;	
	const { ahoverOptions } = attributes;

	if ( ahoverOptions === '' ) {
    return extraProps;
  }                   
	
	let cssstyle = extraProps.style ? { ...extraProps.style } : {};

	const classes = classnames(
		className,  
		{ 		
			[ `p-hover-${ ahoverOptions }` ]: ahoverOptions,					
		}
	);

	return {
		...extraProps, 
		style:  cssstyle,
		className:  classes 
	}

}



addFilter(
	'blocks.registerBlockType',
	'aver/hover-animation-attributes',
	addAttributes
);

addFilter(
	'editor.BlockEdit',
	'aver/hover-animation-advanced-control',
	addInspectorControl
);

addFilter(
	'editor.BlockListBlock',
	'aver/hover-animation-editor-class',
	applyExtraClassEditor,
);

//addFilter('blocks.getSaveContent.extraProps',	'aver/hover-animation-save-class',	applyExtraClassSave  );